const config = {
  availableMenu: [
    { id: "wyjazdy", label: "Wyjazdy", icon: "language" },
    { id: "filtry", label: "Filtry", icon: "filter_list" },
    { id: "statystyki", label: "Statystyki", icon: "assessment" }
  ]
};

export default config;
